module.exports = __webpack_public_path__ + "static/media/clock still 04-mobile.6815b31b.webp";